"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { BlogPanel } from "./BlogPanel";
import BlogFilters from "./BlogFilters";
import { useState } from "react";
import { FilterOption } from "./BlogFilters";
import { normalizeTabType } from "@/lib/center/centerTags";
import { compareResourceGridByDate } from "@/lib/resourceGrid/sortResourceGridCards";
type Props = {
  id: string;
  displayName: string;
  index: number;
  filters: any;
  activeTab: number;
  typeToGather: string[];
  allCards?: object[];
  config?: any;
  loadMoreText?: string;
  mainCardFilters?: FilterOption[];
  lang?: string;
  cardDisplayMode?: string;
};
export default function ResourceGridTab(t0) {
  const $ = _c(49);
  const {
    filters,
    activeTab,
    typeToGather,
    allCards,
    config,
    mainCardFilters,
    lang,
    cardDisplayMode
  } = t0;
  const labelSortByLabel = config?.commonDefaultValues?.labelForSortBy || "Sort By";
  const newestLabel = config?.commonDefaultValues?.labelForNewest || "Newest";
  const oldestLabel = config?.commonDefaultValues?.labelForOldest || "Oldest";
  const loadMoreLabel = config?.commonDefaultValues?.labelForLoadMoreResults || "Load More";
  const labelNoResults = config?.commonDefaultValues?.labelForNoResults || "No Results";
  const labelForClearAll = config?.commonDefaultValues?.labelForClearAll || "Clear All";
  let t1;
  if ($[0] !== newestLabel) {
    t1 = [{
      title: newestLabel,
      id: newestLabel
    }];
    $[0] = newestLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [selectedSorting, setSelectedSorting] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [selectedFilters, setSelectedFilters] = useState(t2);
  let t3;
  if ($[3] !== newestLabel || $[4] !== oldestLabel) {
    t3 = [newestLabel, oldestLabel];
    $[3] = newestLabel;
    $[4] = oldestLabel;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const sortingOptions = t3;
  const [cardLimit, setCardLimit] = useState(18);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = selected => {
      setSelectedFilters(selected);
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleFilterChange = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = selected_0 => {
      setSelectedSorting(selected_0);
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleSortingChange = t5;
  let t6;
  if ($[8] !== selectedFilters) {
    t6 = item => {
      setSelectedFilters(selectedFilters?.filter(selectedFilter => selectedFilter?.id !== item?.id));
    };
    $[8] = selectedFilters;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const handleChipDelete = t6;
  const formattedCardTags = _temp2;
  const checkGridCardType = _temp5;
  let t7;
  if ($[10] !== allCards || $[11] !== cardDisplayMode || $[12] !== mainCardFilters || $[13] !== typeToGather) {
    const typeFilteredCards = allCards?.filter(card_1 => checkGridCardType(typeToGather, card_1));
    t7 = typeFilteredCards?.map(card_2 => {
      card_2.cardTags = formattedCardTags(card_2);
      return card_2;
    })?.filter(card_3 => {
      const shallowTabFilters = mainCardFilters?.map(_temp6).filter(Boolean) ?? [];
      const shallowCardTags = card_3?.cardTags?.map(_temp7).filter(Boolean) ?? [];
      if (shallowTabFilters.length === 0) {
        return true;
      }
      if (cardDisplayMode === "OR") {
        return shallowTabFilters.some(item_0 => shallowCardTags.includes(item_0));
      }
      return shallowTabFilters.every(item_1 => shallowCardTags.includes(item_1));
    });
    $[10] = allCards;
    $[11] = cardDisplayMode;
    $[12] = mainCardFilters;
    $[13] = typeToGather;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const formattedCards = t7;
  let t8;
  bb0: {
    const returnFilteredCards = _temp10;
    if (!formattedCards) {
      let t9;
      if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
          tabCards: undefined,
          showLoadMore: true
        };
        $[15] = t9;
      } else {
        t9 = $[15];
      }
      t8 = t9;
      break bb0;
    }
    let sortedCards;
    let t9;
    if ($[16] !== cardLimit || $[17] !== formattedCards || $[18] !== oldestLabel || $[19] !== selectedFilters || $[20] !== selectedSorting[0]?.title) {
      let cards_0 = formattedCards;
      if (selectedFilters?.length > 0) {
        cards_0 = returnFilteredCards(cards_0, selectedFilters);
      }
      const sortDirection = selectedSorting[0]?.title === oldestLabel ? "oldest" : "newest";
      sortedCards = cards_0?.slice().sort((a, b) => compareResourceGridByDate(a, b, sortDirection));
      t9 = sortedCards?.slice(0, cardLimit);
      $[16] = cardLimit;
      $[17] = formattedCards;
      $[18] = oldestLabel;
      $[19] = selectedFilters;
      $[20] = selectedSorting[0]?.title;
      $[21] = sortedCards;
      $[22] = t9;
    } else {
      sortedCards = $[21];
      t9 = $[22];
    }
    const limitedCards = t9;
    const t10 = sortedCards?.length !== undefined ? sortedCards.length > cardLimit : true;
    let t11;
    if ($[23] !== limitedCards || $[24] !== t10) {
      t11 = {
        tabCards: limitedCards,
        showLoadMore: t10
      };
      $[23] = limitedCards;
      $[24] = t10;
      $[25] = t11;
    } else {
      t11 = $[25];
    }
    t8 = t11;
  }
  const {
    tabCards,
    showLoadMore
  } = t8;
  let t9;
  if ($[26] !== cardLimit) {
    t9 = () => {
      setCardLimit(cardLimit + 18);
    };
    $[26] = cardLimit;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  const loadMoreHandler = t9;
  let t10;
  if ($[28] !== filters) {
    t10 = filters || [];
    $[28] = filters;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== handleChipDelete || $[31] !== labelForClearAll || $[32] !== labelSortByLabel || $[33] !== selectedFilters || $[34] !== selectedSorting || $[35] !== sortingOptions || $[36] !== t10) {
    t11 = <BlogFilters gridFilters={t10} selectedFilters={selectedFilters} sortingOptions={sortingOptions} labelSortBy={labelSortByLabel} labelClearAll={labelForClearAll} handleFilterChange={handleFilterChange} handleSortingChange={handleSortingChange} selectedSorting={selectedSorting} setSelectedSorting={setSelectedSorting} handleChipDelete={handleChipDelete} />;
    $[30] = handleChipDelete;
    $[31] = labelForClearAll;
    $[32] = labelSortByLabel;
    $[33] = selectedFilters;
    $[34] = selectedSorting;
    $[35] = sortingOptions;
    $[36] = t10;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  let t12;
  if ($[38] !== activeTab || $[39] !== labelNoResults || $[40] !== lang || $[41] !== loadMoreHandler || $[42] !== loadMoreLabel || $[43] !== showLoadMore || $[44] !== tabCards) {
    t12 = <BlogPanel cards={tabCards} activeTab={activeTab} loadMoreText={loadMoreLabel} loadMoreHandler={loadMoreHandler} showLoadMore={showLoadMore} imageType="asImage" noResultsText={labelNoResults} lang={lang} />;
    $[38] = activeTab;
    $[39] = labelNoResults;
    $[40] = lang;
    $[41] = loadMoreHandler;
    $[42] = loadMoreLabel;
    $[43] = showLoadMore;
    $[44] = tabCards;
    $[45] = t12;
  } else {
    t12 = $[45];
  }
  let t13;
  if ($[46] !== t11 || $[47] !== t12) {
    t13 = <>{t11}{t12}</>;
    $[46] = t11;
    $[47] = t12;
    $[48] = t13;
  } else {
    t13 = $[48];
  }
  return t13;
}
function _temp10(cards, filters_0) {
  const categorizedFilters = Object?.groupBy(filters_0, _temp8);
  return cards?.filter(card_4 => {
    let displayCard = false;
    const shallowCardTags_0 = card_4?.cardTags?.map(_temp9);
    Object?.values(categorizedFilters)?.every(categoryFilters => {
      displayCard = categoryFilters?.some(categoryFilter => shallowCardTags_0?.includes(categoryFilter?.id));
      if (!displayCard) {
        return false;
      } else {
        return true;
      }
    });
    return displayCard;
  });
}
function _temp9(tag_1) {
  return tag_1?.id;
}
function _temp8(t0) {
  const {
    category
  } = t0;
  return category?.id || "undefined";
}
function _temp7(tag_0) {
  return tag_0?.id;
}
function _temp6(filter) {
  return filter?.id;
}
function _temp5(typeToGather_0, card_0) {
  if (!typeToGather_0 || typeToGather_0.length === 0) {
    return true;
  }
  const checkTypes = typeToGather_0.map(_temp3).filter(_temp4);
  if (checkTypes.length === 0) {
    return true;
  }
  const cardType = card_0?.typeName;
  return checkTypes.includes(cardType);
}
function _temp4(t) {
  return !!t;
}
function _temp3(type) {
  return normalizeTabType(type);
}
function _temp2(card) {
  return card?.tagsCollection?.items?.map(_temp);
}
function _temp(tag) {
  return {
    id: tag?.sys?.id,
    title: tag?.displayName,
    category: {
      id: tag?.categoryCollection?.items[0]?.sys?.id,
      title: tag?.categoryCollection?.items[0]?.displayName
    }
  };
}